import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, map } from 'rxjs';
import { ApiGatewayService } from './api-gateway.service';
import { LocalStorageService } from './local-storage.service';
import { User } from '../models/user.model';
import { ClientVersion } from '../models/client-version.model';

@Injectable({ providedIn: 'root' })
export class ClientVersionService {
  private readonly apiGatewayService = inject(ApiGatewayService);
  private readonly localStorageService = inject(LocalStorageService);

  private clientVersionSubject = new BehaviorSubject<ClientVersion | null>(null);
  clientVersion$ = this.clientVersionSubject.asObservable();

  async getCurrentVersionAsync(user: User | null): Promise<ClientVersion> {
    const clientVersion$ = this.apiGatewayService
      .get<{
        clientVersion: ClientVersion;
      }>(user ? 'oss/clientversion/index' : 'oss/clientversion/getclientversionpublic', '1.0.0', {
        client_name: 'dashboard_app',
      })
      .pipe(map((response) => response.clientVersion));
    const clientVersion = await firstValueFrom(clientVersion$);
    await this.localStorageService.setClientVersion(clientVersion);
    this.clientVersionSubject.next(clientVersion);
    return clientVersion;
  }

  clearClientVersion(): void {
    this.clientVersionSubject.next(null);
  }
}
